import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const BUYERS = [{
  name: 'Camila M.',
  location: 'Buenos Aires, AR'
}, {
  name: 'Valentina R.',
  location: 'Bogotá, CO'
}, {
  name: 'Luciana P.',
  location: 'Lima, PE'
}, {
  name: 'Mariana G.',
  location: 'CDMX, MX'
}, {
  name: 'Isabella F.',
  location: 'Santiago, CL'
}, {
  name: 'Daniela S.',
  location: 'Medellín, CO'
}, {
  name: 'Florencia L.',
  location: 'Montevideo, UY'
}, {
  name: 'Catalina V.',
  location: 'Quito, EC'
}, {
  name: 'Antonella B.',
  location: 'Córdoba, AR'
}, {
  name: 'Renata H.',
  location: 'Guadalajara, MX'
}, {
  name: 'Agustina T.',
  location: 'Rosario, AR'
}, {
  name: 'Carolina D.',
  location: 'Caracas, VE'
}];
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/uMzJ39PhZGMNWKmbsEbdFP/MOCKUPPREMIUM.png';
function getRandomTime(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function getTimeAgo() {
  const mins = getRandomTime(1, 12);
  return `hace ${mins} min`;
}
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeAgo, setTimeAgo] = useState(getTimeAgo());
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showNext = useCallback(() => {
    if (dismissed) return;
    setCurrentIndex(prev => (prev + 1) % BUYERS.length);
    setTimeAgo(getTimeAgo());
    setVisible(true);
    // Hide after 5 seconds
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
      // Show next after random 15-30 seconds
      timeoutRef.current = setTimeout(() => {
        showNext();
      }, getRandomTime(15000, 30000));
    }, 5000);
  }, [dismissed]);
  useEffect(() => {
    // First appearance after 6 seconds
    timeoutRef.current = setTimeout(() => {
      showNext();
    }, 6000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  // Stop cycling if dismissed
  useEffect(() => {
    if (dismissed) {
      setVisible(false);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    }
  }, [dismissed]);
  const buyer = BUYERS[currentIndex];
  return <AnimatePresence data-id="element-392">
      {visible && !dismissed && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:w-[380px] z-50" data-id="element-393">
          <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.12)] border border-gray-100 overflow-hidden" data-id="element-394">
            {/* Top accent line */}
            <div className="h-[2px] bg-gradient-to-r from-pink-light to-pink-dark" data-id="element-395" />

            <div className="flex items-center gap-3 p-3 pr-2" data-id="element-396">
              {/* Product image */}
              <div className="w-[64px] h-[64px] flex-shrink-0 rounded-xl overflow-hidden bg-beige" data-id="element-397">
                <img src={PRODUCT_IMAGE} alt="Bikinis al Crochet + 5 Bonos" className="w-full h-full object-cover" draggable={false} data-id="element-398" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-399">
                <div className="flex items-center gap-1.5 mb-0.5" data-id="element-400">
                  <span className="w-2 h-2 rounded-full bg-emerald-400 flex-shrink-0 animate-pulse" data-id="element-401" />
                  <span className="font-body text-[11px] font-semibold text-emerald-600 uppercase tracking-wide" data-id="element-402">
                    Compra reciente
                  </span>
                </div>
                <p className="font-body text-sm text-dark-gray leading-snug" data-id="element-403">
                  <span className="font-bold" data-id="element-404">{buyer.name}</span>{' '}
                  <span className="text-medium-gray" data-id="element-405">de {buyer.location}</span>
                </p>
                <p className="font-body text-xs text-medium-gray mt-0.5" data-id="element-406">
                  Bikinis al Crochet + Bonos ·{' '}
                  <span className="font-bold text-pink-dark" data-id="element-407">$14</span>
                  <span className="text-medium-gray/60 ml-1.5" data-id="element-408">
                    · {timeAgo}
                  </span>
                </p>
              </div>

              {/* Close button */}
              <button onClick={() => setDismissed(true)} className="p-1.5 rounded-full hover:bg-gray-100 transition-colors flex-shrink-0 self-start" aria-label="Cerrar notificación" data-id="element-409">
                <XIcon className="w-4 h-4 text-medium-gray" data-id="element-410" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}